import { render, staticRenderFns } from "./DocumentAIP.vue?vue&type=template&id=cd8fe06e&scoped=true&"
import script from "./DocumentAIP.vue?vue&type=script&lang=js&"
export * from "./DocumentAIP.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAIP.vue?vue&type=style&index=0&id=cd8fe06e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8fe06e",
  null
  
)

export default component.exports